module.exports = __webpack_public_path__ + "static/media/okkk.14c37b2d.png";